import { intersection } from '../utils/immutable'

export const createPermissionsAll = (permissions = []) => ({ access = {} }) => {
  if (!access.permissions_slug_index && !access.permissions_slug_new_index) return false
  if (!permissions.length) return true

  return permissions.reduce((r, x) => r && (access.permissions_slug_index[x] || access.permissions_slug_new_index[x]), true)
}

export const createPermissionsAny = (permissions = []) => ({ access = {} }) => {
  if (!access.permissions_slug_index && !access.permissions_slug_new_index) return false
  if (!permissions.length) return true

  return permissions.reduce((r, x) => r || (access.permissions_slug_index[x] || access.permissions_slug_new_index[x]), false)
}

export const createExlusionsAll = (exclusions = []) => ({ access = {} }) => {
  return !!exclusions.length && intersection(
    Object.keys(access),
    exclusions,
    (a, b) => a === b
  ).length === exclusions.length
}

export const createSettingsAll = (settings = []) => ({ access = {} }) => {
  if (!settings.length) return true

  return intersection(
    Object.entries(access?.settings || {}).filter(([_, v]) => v).map(([k]) => k),
    settings,
    (a, b) => a === b
  ).length === settings.length
}

export const createSettingsAny = (settings = []) => ({ access = {} }) => {
  if (!settings.length) return true

  return intersection(
    Object.entries(access?.settings || {}).filter(([_, v]) => v).map(([k]) => k),
    settings,
    (a, b) => a === b
  ).length >= 1
}
